<div
  class="alert alert-error__container d-flex"
  style="justify-content: space-between; align-items: center"
  role="alert"
  *ngIf="message"
>
  <div>
    <img src="assets/images/icons/warning.svg" style="margin-top: -4px" />
    <span class="alert-error__msg mx-2">{{ message }}</span>
  </div>
  <i
    (click)="close()"
    class="fa fa-close"
    style="color: #727385; cursor: pointer"
  ></i>
</div>
